import axios from '../helper/axios';
import { mailConstants } from './constants';

export const sendMessage =
  ({ name, email, message }) =>
  async (dispatch) => {
    try {
      const body = { name, email, message };

      dispatch({ type: mailConstants.SEND_MAIL_REQUEST });

      const res = await axios.post(`/sendmail/send`, body);

      if (res.status === 201) {
        return dispatch({
          type: mailConstants.SEND_MAIL_SUCCESS,
          payload: {
            message: 'Message sent!',
          },
        });
      }
      dispatch({
        type: mailConstants.SEND_MAIL_FAILURE,
        payload: {
          error: res.data.message,
        },
      });
    } catch (err) {
      dispatch({
        type: mailConstants.SEND_MAIL_FAILURE,
        payload: {
          error: err.message,
        },
      });
    }
  };
